module.exports = __webpack_public_path__ + "img/40.03513b8b.jpg";